import { execAdmin } from '@src/apis/reware/utils';

import type {
  ShopifyProductRedirectConnection,
  FetchRedirectsExecVariables,
  FetchRedirectsExecResponse,
} from './types';

export interface FetchRedirectsArgs {
  partnerCode: string;
  first?: number;
  after?: string | null;
  status?: string;
  handle?: string;
  catalogItemId?: number;
}

export const fetchRedirects = async ({
  partnerCode,
  first = 50,
  after = null,
  status,
  handle,
  catalogItemId,
}: FetchRedirectsArgs): Promise<ShopifyProductRedirectConnection> => {
  const query = `
    query getShopifyProductRedirects(
      $partnerCode: String!
      $first: Int
      $after: String
      $status: String
      $handle: String
      $catalogItemId: Int
    ) {
      shopifyProductRedirects(
        partnerCode: $partnerCode
        first: $first
        after: $after
        status: $status
        handle: $handle
        catalogItemId: $catalogItemId
      ) {
        edges {
          node {
            id
            partnerCode
            subdomain
            shopifyProductId
            catalogItemId
            shopifyRedirectId
            fromHandle
            toHandle
            currentTarget
            status
            createdAt
            updatedAt
            catalogItem {
              id
              title
              sku
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          startCursor
          endCursor
        }
        totalCount
      }
    }
  `;

  const variables: FetchRedirectsExecVariables = {
    partnerCode,
    first,
    after,
  };
  if (status) variables.status = status;
  if (handle) variables.handle = handle;
  if (catalogItemId) variables.catalogItemId = catalogItemId;

  const data = await execAdmin<FetchRedirectsExecVariables, FetchRedirectsExecResponse>(
    query,
    { variables },
  );

  const result = data.shopifyProductRedirects;
  if (!result) {
    throw new Error(
      `fetchRedirects: unexpected response — shopifyProductRedirects is ${result === null ? 'null' : 'undefined'} (partnerCode=${partnerCode})`,
    );
  }

  return result;
};
